module.exports = __webpack_public_path__ + "static/media/thumbnail.74e97ef4.jpg";